import { format } from '@office-start/string-formatter-utility';
export function formatConsentDialogStrings(appName, unformattedStrings) {
    return {
        title: format(unformattedStrings.title, appName),
        requestPermissionToDevice: format(unformattedStrings.requestPermissionToDevice, appName),
        updateAnyTimeNotice: format(unformattedStrings.updateAnyTimeNotice, appName),
        allowButtonLabel: unformattedStrings.allowButtonLabel,
        denyButtonLabel: unformattedStrings.denyButtonLabel,
        closeButtonAria: unformattedStrings.closeButtonAria,
    };
}
//# sourceMappingURL=formatConsentDialogStrings.js.map